import { f as _typeof, d as _objectSpread2, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import '../packages/injecss.js';
import { Avatar } from './avatar.js';
import { I as IconProfile } from '../index-1707f584.js';
import './icon.js';
import { H as HeaderNavigationPropTypes, s as styles } from '../header-navigation-proptypes-340eaeea.js';
import { HeaderNavigation } from './header.js';

var bem = Bem('header-user-widget', styles);
var HeaderUserWidget = function HeaderUserWidget(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      extraClasses = _ref.extraClasses,
      navigation = _ref.navigation,
      src = _ref.src,
      text = _ref.text,
      url = _ref.url;
  // @todo simplify this possibly when 'as' props are unified among components
  // customizing Avatar props depending on if RouterLink passed
  var avatarProps = _typeof(url) === 'object' && url.RouterLink ? _objectSpread2({
    as: url.RouterLink
  }, url) : {
    url: url
  };
  delete avatarProps.RouterLink; // removes redundant RouterLink prop as Avatar accepts "as"
  // if custom RouterLink component passed
  // change object structure of nav item being passed to HeaderNavigation accordingly

  var userProfileNavItem = _typeof(url) === 'object' && url.RouterLink ? _objectSpread2({
    content: text
  }, url) : {
    href: url,
    content: text
  }; // assembling navigation array for HeaderNavigation component,
  // if navigation is passed we remove the link from username text

  var userProfileNav = navigation ? [{
    content: text,
    children: navigation
  }] : [userProfileNavItem];
  return React.createElement("div", {
    className: bem.b(false, extraClasses)
  }, React.createElement(Avatar, _extends({}, avatarProps, {
    src: src,
    alt: alt,
    extraClasses: bem.e('picture')
  }), children), React.createElement("div", {
    className: bem.e('content')
  }, React.createElement(HeaderNavigation, {
    navigation: userProfileNav
  })));
};
HeaderUserWidget.displayName = 'HeaderUserWidget';
HeaderUserWidget.defaultProps = {
  alt: '',
  children: React.createElement(IconProfile, {
    style: {
      fill: 'white'
    }
  }),
  // header needs white version of the icon
  extraClasses: '',
  navigation: null,
  src: null
};
HeaderUserWidget.propTypes = {
  /** avatar image alt text */
  alt: PropTypes.string,

  /** custom image element, you can pass a component, icon or inline SVG in here */
  children: PropTypes.node,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Array used to construct the navigation, has following structure:
   * {
   *    content - defines link text
   *    href - specifies link URL
   *    current - defines if this item is the current active one
   *    RouterLink - pass custom RouterLink if you need support for ReactRouter or similar libraries
   * }
   */
  navigation: HeaderNavigationPropTypes,

  /** url of the avatar image, default icon gets displayed if none provided */
  src: PropTypes.string,

  /** text displayed aside the avatar, should be user's name in most of the cases */
  text: PropTypes.string.isRequired,

  /** Url for picture and profile link if no navigation items provided.
   * If you need support for custom link component, pass it as object consisting of:
   * { RouterLink: YourLinkComponent, ...yourLinkComponentProps } */
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  })]).isRequired
};

export { HeaderUserWidget };
